module.exports = __webpack_public_path__ + "img/content-img-2.782a7c34.jpg";